import { Action } from 'redux';
import { initializeState } from 'src/utils/Initial';
import { isType } from 'typescript-fsa';
import * as Actions from '../actions/skill';
import { ICareerMapCell, ICareerMapFieldList } from '../actions/skill';

export interface ISkstate<T> {
	data: T[];
	selectedColumns: number[];
	setDataAt?: Date;
}

/**
 * スキル情報のState型
 */
export interface ISkillState {
	readonly onGoingSkill: ISkstate<Actions.IOnGoingSkill>;
	readonly onGoingSkillMap: ISkstate<Actions.IOnGoingSkillMap>;
	readonly resultSkill: ISkstate<Actions.IResultSkill>;
	readonly resultSkillMap: ISkstate<Actions.IResultSkillMap>;
	readonly careerMapFieldList: ICareerMapFieldList;
	readonly careerMapCellList: ICareerMapCell[];
}

/**
 * スキル情報のState初期値
 */
const initialState: ISkillState = {
	careerMapCellList: [],
	careerMapFieldList: {
		careerMapName: '',
		fieldlevelOne: [],
		fieldlevelThree: [],
		fieldlevelTwo: [],
	},
	onGoingSkill: {
		data: [],
		selectedColumns: [0, 1, 3, 4, 5, 6, 7, 8],
	},
	onGoingSkillMap: {
		data: [],
		selectedColumns: [0, 1, 3, 4, 5, 6],
	},

	resultSkill: {
		data: [],
		selectedColumns: [0, 1, 3, 4, 5, 6, 7, 8, 9],
	},
	resultSkillMap: {
		data: [],
		selectedColumns: [0, 1, 3, 4, 5],
	},
};

/**
 * スキル情報用reducer
 * @param state State
 * @param action アクション
 */
const imstat = (state: ISkillState, action: Action) => {
	if (!state) {
		// State初期化処理
		state = initialState;
		state = initializeState(state);
	}

	if (isType(action, Actions.setOnGoingSkillSelectedColumns)) {
		return {
			...state,
			onGoingSkill: {
				...state.onGoingSkill,
				selectedColumns: action.payload.selectedColumns,
			},
		};
	}

	if (isType(action, Actions.setOnGoingSkillMapSelectedColumns)) {
		return {
			...state,
			onGoingSkillMap: {
				...state.onGoingSkillMap,
				selectedColumns: action.payload.selectedColumns,
			},
		};
	}

	if (isType(action, Actions.setResultSkillSelectedColumns)) {
		return {
			...state,
			resultSkill: {
				...state.resultSkill,
				selectedColumns: action.payload.selectedColumns,
			},
		};
	}

	if (isType(action, Actions.setResultSkillMapSelectedColumns)) {
		return {
			...state,
			resultSkillMap: {
				...state.resultSkillMap,
				selectedColumns: action.payload.selectedColumns,
			},
		};
	}

	if (isType(action, Actions.setOnGoingSkillMapData)) {
		return {
			...state,
			onGoingSkillMap: {
				...state.onGoingSkillMap,
				data: action.payload.skillMapData,
			},
		};
	}

	if (isType(action, Actions.setOnGoingSkillData)) {
		return {
			...state,
			onGoingSkill: {
				...state.onGoingSkill,
				data: action.payload.skillData,
			},
		};
	}

	if (isType(action, Actions.setResultSkillMapData)) {
		return {
			...state,
			resultSkillMap: {
				...state.resultSkillMap,
				data: action.payload.skillMapData,
			},
		};
	}
	if (isType(action, Actions.setResultSkillData)) {
		return {
			...state,
			resultSkill: {
				...state.resultSkill,
				data: action.payload.skillData,
			},
		};
	}

	if (isType(action, Actions.setCareerMapFieldList)) {
		return {
			...state,
			careerMapFieldList: {
				...state.careerMapFieldList,
				careerMapName: action.payload.careerMapName,
				fieldlevelOne: action.payload.fieldlevelOne,
				fieldlevelThree: action.payload.fieldlevelThree,
				fieldlevelTwo: action.payload.fieldlevelTwo,
			},
		};
	}

	if (isType(action, Actions.setCareerMapCellData)) {
		return {
			...state,
			careerMapCellList: action.payload.careerMapCellList,
		};
	}

	return state;
};

export default imstat;



// WEBPACK FOOTER //
// ./src/reducers/skill.ts